import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { PlColumnActions } from '../actions';

@Injectable()
export class PlColumnEffects {
  loadPlColumn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlColumnActions.plColumnLoadRequested),
      map(({ entries }) =>
        PlColumnActions.plColumnLoaded({ entries })
      )
    )
  );

  addPlColumn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlColumnActions.plAddColumnRequested),
      map(({entry}) => PlColumnActions.plColumnAdded({ entry }))
    )
  );

  constructor(private actions$: Actions, private store: Store<AppState>) {}
}
